import classNames from "classnames";
import styles from "../styles/login.module.scss";
import {observer} from "mobx-react";
import {shareState} from "../../../app/share-state";
import {Image} from "../../../components/image/image";
import {XRequestParams} from "../../../icons/x-icon";

export const LoginWidgetDateOfBirth = observer(({controller}) => {
  const {state: {dateOfBirth, dateOfBirthHasError}} = controller;

  const inputProps = {
    type: "date",
    value: dateOfBirth,
    className: classNames(
      styles.date_of_birth_input,
      {[styles.date_of_birth_input_error]: dateOfBirthHasError}
    ),
    onChange: (e) => controller.setDateOfBirth(e.target.value),
    onBlur: () => controller.validateDateOfBirthOnBlur(),
    placeholder: "DD/MM/YYYY"
  }

  const errorIconProps = {
    className: classNames(styles.date_of_birth_validation_icon),
    src: new XRequestParams(16, 16)
  }

  return (
    <div className={classNames(styles.date_of_birth_container)}>
      <label className={classNames(styles.date_of_birth_label)}>
        {shareState.termsUtils.terms.BOLAO_ATLEAST_18REQUIRED}
      </label>
      <input {...inputProps}/>
      {
        dateOfBirthHasError ? (<Image {...errorIconProps}/>) : null
      }
    </div>
  )
});
